module.exports = __webpack_public_path__ + "static/media/girav.4858a719.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/girav.webp
// module id = 491
// module chunks = 0